import React from "react";
import get from "lodash/get";
import { object } from "prop-types";
import { collectionToStories } from "@quintype/components";
import CardImageType4 from "../../molecules/card-image-type-4";
import CardImageType5 from "../../molecules/card-image-type-5";
import CardImageType8 from "../../molecules/card-image-type-8";
import { SectionCategoryTitle } from "../../molecules/section-category-title";

import "./one-big-6-small-img-news-cols.m.css";

const OneBigSixSmallImgNewsCols = ({ collection }) => {
  const showSection = get(collection, ["associated-metadata", "Näytä_kokoelman_otsikko"], false);
  let kokoelmanVaripohja = get(collection, ["associated-metadata", "Jos haluat kokoelmaan väripohjan, voit kirjoittaa sen tähän (vaihtoehdot=> musta, persikka, keltainen tai violetti)"], []);
  if(kokoelmanVaripohja.length==0){
    kokoelmanVaripohja="";
  }
  if((kokoelmanVaripohja !== "musta") && (kokoelmanVaripohja !== "keltainen") && (kokoelmanVaripohja !== "violetti") && (kokoelmanVaripohja !== "persikka")) {
    kokoelmanVaripohja="valkoinen";
  }

  const storiesFromCollection = collectionToStories(collection);
  if (storiesFromCollection.length < 1) {
    return null;
  }
  const [firstStory, ...restOftheStories] = storiesFromCollection || [];

  return (
    <React.Fragment>
      <div styleName={`wrapper ${kokoelmanVaripohja}`}>
        <div styleName="container">
          <div styleName="inner-wrapper1">
            {showSection &&<div><SectionCategoryTitle name={collection.name} /></div>}
            {<div styleName="first-story first-story1">
              <CardImageType5 story={firstStory} showSubHeadline ={false}/>
            </div>}
            <div styleName="item-wrapper1">
              {restOftheStories.length >= 1 &&
                restOftheStories.slice(0, 6).map((item, index) =>
                  <React.Fragment key={index}>
                    <div styleName="item" className="item" key={item.id}>
                      <div styleName="desktop-tablet-only">
                      <CardImageType4 story={item} />
                      </div>
                      <div styleName="mobile-only">
                      <CardImageType8 story={item} />
                      </div>
                    </div>
                  </React.Fragment>
                )
              }
            </div>
          </div>
        </div>
      </div>

    </React.Fragment>
  );
};

OneBigSixSmallImgNewsCols.propTypes = {
  collection: object
};
export { OneBigSixSmallImgNewsCols };

OneBigSixSmallImgNewsCols.storyLimit = 22;
